import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  backdrop-filter: blur(4px);

  @media (max-width: 880px) {
    .btn-row {
      display: none;
    }
  }
`;

export const CountGroup = styled.div`
  display: flex;
  align-items: center; /* 👈 하단 정렬 */
  gap: 10px;
  font-weight: 700;
  white-space: nowrap;

  span {
    font-weight: 600;
    color: #4b5563;
  }
  b {
    color: #111827;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Button = styled.button<{ $variant?: string }>`
  --fg: #111827;
  --bg: #ffffff;
  --bd: #e5e7eb;
  --hover-bg: #ffffff;
  --hover-bd: #d1d5db;

  ${({ $variant }) => {
    switch ($variant) {
      case "success":
        return `
          --fg: #065f46;
          --bg: #ecfdf5;
          --bd: #a7f3d0;
          --hover-bg: #d1fae5;
          --hover-bd: #6ee7b7;
        `;
      case "warning":
        return `
          --fg: #7c2d12;
          --bg: #fff7ed;
          --bd: #fed7aa;
          --hover-bg: #ffedd5;
          --hover-bd: #fdba74;
        `;
      case "info":
        return `
          --fg: #0c4a6e;
          --bg: #eff6ff;
          --bd: #bfdbfe;
          --hover-bg: #dbeafe;
          --hover-bd: #93c5fd;
        `;
      case "danger":
        return `
          --fg: #7f1d1d;
          --bg: #fef2f2;
          --bd: #fecaca;
          --hover-bg: #fee2e2;
          --hover-bd: #fca5a5;
        `;
      default:
        return "";
    }
  }}

  position: relative;
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--bd);
  background: var(--bg);
  color: var(--fg);
  font-size: 12.5px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: var(--hover-bg);
    border-color: var(--hover-bd);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

/* --- 모바일 메뉴 --- */
export const MenuWrap = styled.div`
  position: relative;
  margin-left: 8px;
  display: none;
  @media (max-width: 880px) {
    display: block;
  }
`;

export const MenuButton = styled(Button)`
  height: 36px;
  padding: 0 12px;
`;

export const MenuList = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.18), 0 2px 6px rgba(2, 6, 23, 0.08);
  padding: 8px;
  z-index: 40;
`;

export const MenuItem = styled.button<{ $disabled?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  background: transparent;
  color: ${({ $disabled }) => ($disabled ? "#9ca3af" : "#0f172a")};
  font-size: 14px;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  text-align: left;

  &:hover {
    background: ${({ $disabled }) => ($disabled ? "transparent" : "#f3f4f6")};
  }
`;

export const Dim = styled.div`
  @media (max-width: 880px) {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.1);
    z-index: 30;
  }
`;
